import { observer } from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import { useEffect } from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import GeneralTextsEditor from "./general-texts-editor";

const GeneralTextsEditorPage: React.FC = observer(() => {
    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles(['Portal', 'Content', 'General Texts']);
    }, [setSubTitles]);

    const { selectedLocale } = useTranslation();
    
    return (
        <TranslationScope scope="tracking-portal" locale={selectedLocale}>
            <GeneralTextsEditor />
        </TranslationScope>
    );
});

export default GeneralTextsEditorPage;